<template>
    <div v-if="canOpen && isUserLogged">
        <div v-for="item in Object.keys(relatedActsView)" :key="item">
            <p class="tab-label">{{ tabCodes[item].label }}</p>
            <p class="act-label" v-for="act in relatedActsView[item]" :key="act.Id"
                @click="handleActClick(act, tabCodes[item].base)">{{ act.actName
                }}</p>
        </div>
    </div>
    <div v-else-if="isUserLogged && !canOpen">
        <p class="tab-label">Немате довољни ниво привилегија за приступ овом делу портала</p>
    </div>
    <div v-else>
        <p class="tab-label">Пријавите се како бисте добили приступ овом делу портала</p>
    </div>
</template>

<script>
import tabs from '@/utils/reg-related-act-tabs.js';
import * as roleService from '@/services/role-service'
import { mapState } from "vuex";

export default {
    name: 'RelatedActsView',
    data() {
        return {
            tabCodes: tabs,
            contentApiBase: {
                'supa': `${window.env.VUE_APP_API_SP_DEV}prins/viewAct/`,
                'mml': `${window.env.VUE_APP_API_MML_DEV}prins/ViewAct/`
            }
        }
    },
    props: {
        relatedActsView: {
            type: Object,
            required: true,
        }
    },
    methods: {
        handleActClick(act, base) {
            let selectedActId = base === 'mml' ? act.actId : act.htmlGuid;
            let contentType = base === 'mml' && act.pdfGuid ? 'pdf' : 'html';
            this.$emit('act-click', this.contentApiBase[base] + selectedActId, contentType);
        }
    },
    computed: {
        ...mapState(["userInfoState"]),
        isUserLogged() {
            return this.userInfoState ? true : false;
        },
        canOpen() {
            return this.userInfoState ? roleService.hasFullAccessForRoles(this.userInfoState.roles) : false;
        }
    }
}
</script>

<style scoped>
.tab-label {
    font-weight: bold;
}

.act-label {
    cursor: pointer;
    padding: 10px 0px;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
    font-weight: 400;
    font-style: italic;
    color: #5dbb49;
    text-align: left;
    margin: 0px;
    display: block;
    width: 100%;
}

.act-label:hover {
    background-color: #f7f7f7;
}
</style>